import _ from 'underscore';
import { PreferencesSubadapter } from '@bingads-webui-component-legacy/bingads-grid/service/preference-subadapter';
import { store, adapter } from '@bingads-webui-component-legacy/bingads-grid/service/grid-preferences';


export const LegacyColumns = store.defineResource('LegacyColumns');
export const LegacySelectedColumns = store.defineResource('LegacySelectedColumns');

adapter.registerSubadapter('LegacyColumns', new PreferencesSubadapter({
  Resource: LegacyColumns,
  prefix({
    where: {
      project = 'CampaignUI',
      grid = null,
    } = {},
  } = {}) {
    if (_.some([project, grid], _.negate(_.isString))) {
      throw new Error('Invalid where clause');
    }

    return `WebApp.${project}.Columns.${grid}`;
  },

  serialize(attrs) {
    const { id, project, grid, columns, name } = attrs;

    if (_.some([project, grid, name], _.negate(_.isString)) || !_.isArray(columns)) {
      throw new Error('Invalid attributes');
    }

    return {
      Id: id,
      Name: `WebApp.${project}.Columns.${grid}.${name}`,
      Data: columns,
      Type: 'array',
      Version: 1,
    };
  },

  deserialize(data) {
    const matchCustom = data.Name.match(/^WebApp\.(\w+)\.Columns\.(\w+)_custom$/);

    if (matchCustom) {
      const [project, grid] = matchCustom.slice(1);
      const columns = data.Data;
      const id = data.Id;

      return { id, project, grid, name: 'Custom', columns };
    }

    // legacy save custom as gridName_custom, which break the rule of gridName.[name],
    // so we have to filter out gridName_selected, which is used to save applied record name
    const matchSelected = data.Name.match(/^WebApp\.(\w+)\.Columns\.(\w+)_selected$/);

    if (matchSelected) {
      return { id: -1 };
    }

    const match = data.Name.match(/^WebApp\.(\w+)\.Columns\.(\w+)\.(.*)$/);

    if (!match) {
      throw new Error('Invalid preference name');
    }

    const [project, grid, name] = match.slice(1);
    const columns = data.Data;
    const id = data.Id;

    return { id, project, grid, name, columns };
  },
}));

adapter.registerSubadapter('LegacySelectedColumns', new PreferencesSubadapter({
  Resource: LegacySelectedColumns,
  prefix({
    where: {
      project = 'CampaignUI',
      grid = null,
    } = {},
  } = {}) {
    if (_.some([project, grid], _.negate(_.isString))) {
      throw new Error('Invalid where clause');
    }

    return `WebApp.${project}.Columns.${grid}_selected`;
  },

  serialize(attrs) {
    const { id, project, grid, name } = attrs;

    if (_.some([project, grid, name], _.negate(_.isString))) {
      throw new Error('Invalid attributes');
    }

    return {
      Id: id,
      Name: `WebApp.${project}.Columns.${grid}_selected`,
      Data: `WebApp.${project}.Columns.${grid}.${name}`,
      Type: 'string',
      Version: 1,
    };
  },

  deserialize(data) {
    const match = data.Name.match(/^WebApp\.(\w+)\.Columns\.(\w+)_selected$/);

    if (!match) {
      throw new Error('Invalid preference name');
    }

    const [project, grid] = match.slice(1);
    const id = data.Id;
    let name;

    if (data.Data === `WebApp.${project}.Columns.${grid}_custom`) {
      name = 'Custom';
    } else {
      name = data.Data.replace(`WebApp.${project}.Columns.${grid}.`, '');
    }

    return { id, project, grid, name };
  },
}));
